<template>
    <div v-show="isLessonHistory || isExporting">
        <Lesson v-for="(lesson, index) in lessons" :key="'lesson-' + index" :lesson="lesson"></Lesson>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import Store from '../../state/teachingCardStore';
import Lesson from './Lesson';

const lessons = computed(() => Store.getLessons());
const showDetailedTeachingCard = computed(() => Store.displayDetailed());
const isExporting = computed(() => Store.isExporting());
const isLessonHistory = computed(() => Store.isLessonHistory());
</script>
